(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9708],{

/***/ 38628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ CMSChildrenContainer; },
  "Z": function() { return /* binding */ ChildrenContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./utils/stylesHelper.ts
// Future improvement could be to add baseClasses as a potential array - either array or string
// if (Array.isArray(baseClass)) { return [...baseClass, className].join(" ")
function combineClasses(baseClass, className) {
    return className ? "".concat(baseClass, " ").concat(className) : baseClass;
}

// EXTERNAL MODULE: ./components/CMS/ChildrenContainer/style.module.scss
var style_module = __webpack_require__(88460);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/CMS/ChildrenContainer/index.tsx




var CMSChildrenContainer = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: combineClasses((style_module_default()).childrenContainer, className),
        children: children
    });
};
/* harmony default export */ var ChildrenContainer = (CMSChildrenContainer);


/***/ }),

/***/ 8037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MarkdownCMSModule; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88415);
/* harmony import */ var _cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30724);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_CMS_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70738);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57231);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_5__);







var MarkdownCMSModule = function(param) {
    var source = param.source, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_markdown__WEBPACK_IMPORTED_MODULE_3___default()), {
        renderers: components_CMS_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
        className: className !== null && className !== void 0 ? className : classnames__WEBPACK_IMPORTED_MODULE_1___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().markdown), (_cmsComponents_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().markdownContent)),
        escapeHtml: false,
        children: source
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownCMSModule);


/***/ }),

/***/ 70738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29260);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91066);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable react/display-name */ 



var MarkdownRenderer = {
    link: function(props) {
        var href = props.href, children = props.children;
        var shouldUseTargetSelf = /^(https?):\/\//.test(href) ?  true ? href.startsWith(window.location.origin) // In case someone pastes the full URL
         : 0 : /*
         * Anything else should use target="_self". Especially anything that starts with mailto, tel, or javascript
         */ true;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: shouldUseTargetSelf ? "_self" : "_blank",
            rel: "noreferrer noopener",
            children: children
        });
    },
    image: function(props) {
        var src = props.src, title = props.title;
        if (src.match(/\.(jpeg|jpg|gif|png)$/)) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: src,
                        style: {
                            display: "block",
                            width: "80%",
                            height: "400px",
                            objectFit: "cover",
                            margin: "0 auto"
                        },
                        alt: "cover image"
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imageAndLinkTitle),
                        children: title
                    })
                ]
            });
        }
        if (src.match(/\.(mp4|ogg|webm)$/)) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                        controls: true,
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().videoPlayer),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                            src: src
                        })
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().imageAndLinkTitle),
                        children: title
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownRenderer);


/***/ }),

/***/ 59708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Testimonial": function() { return /* binding */ Testimonial; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/CMS/ChildrenContainer/index.tsx + 1 modules
var ChildrenContainer = __webpack_require__(38628);
// EXTERNAL MODULE: ./components/CMS/style.module.scss
var style_module = __webpack_require__(88415);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/CMS/MarkdownCMSModule/index.tsx
var MarkdownCMSModule = __webpack_require__(8037);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/CMS/Testimonial/img/close_quote.png
/* harmony default export */ var close_quote = ({"src":"https://cdn.medrecruit.medworld.com/01bece67e9188f0472a5b297e49e6691a1431f4c/_next/static/media/close_quote.f9980915.png","height":50,"width":61,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAKlBMVEUmi+AmiuBMaXEmiuAmiuAmit8miuAmit8mit8mi+Amit8mi+Amit8miuD542gMAAAADXRSTlORIgC/UfMHXhPVPdpsbQB0mgAAAAlwSFlzAAALEwAACxMBAJqcGAAAADNJREFUCJkFwYkBgDAMxDDn0tIHvP+6SLT91Cuoa6kw5ekpKb9kSO7cCU2dkYxTcJNi5wcvcgFGs66GLAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./components/CMS/Testimonial/img/open_quote.png
/* harmony default export */ var open_quote = ({"src":"https://cdn.medrecruit.medworld.com/01bece67e9188f0472a5b297e49e6691a1431f4c/_next/static/media/open_quote.e12639bc.png","height":50,"width":61,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAJ1BMVEUmiuAmiuAmi+Amit8mit8miuAmit8mi+Ami+AmiuAmit8miuAmit8XX2HPAAAADXRSTlP+Ae+jiixUG9pMwj1hU++eoAAAAAlwSFlzAAALEwAACxMBAJqcGAAAADFJREFUCJkFwYcBwCAMwDA7gzD6/72VcPLpS2YvPXu4qcYRSg9LIPqDS0A1wIrdFvkDHLwAzZ0vni0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./components/CMS/Testimonial/style.module.scss
var Testimonial_style_module = __webpack_require__(44993);
var Testimonial_style_module_default = /*#__PURE__*/__webpack_require__.n(Testimonial_style_module);
;// CONCATENATED MODULE: ./components/CMS/Testimonial/item.tsx








var TestimonialItem = function(param) {
    var data = param.data, background = param.background;
    var author_name = data.author_name, quote = data.quote, job_title = data.job_title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Testimonial_style_module_default()).itemContainer, background ? (Testimonial_style_module_default()).blueBox : (Testimonial_style_module_default()).none),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Testimonial_style_module_default()).beforeQuote,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: open_quote,
                            alt: "open quote"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownCMSModule/* MarkdownCMSModule */.R, {
                        source: quote,
                        className: (Testimonial_style_module_default()).quote
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Testimonial_style_module_default()).afterQuote,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: close_quote,
                            alt: "close quote"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Testimonial_style_module_default()).name,
                children: [
                    author_name,
                    " ",
                    job_title && ", ".concat(job_title)
                ]
            })
        ]
    });
};
/* harmony default export */ var item = (TestimonialItem);

;// CONCATENATED MODULE: ./components/CMS/Testimonial/index.tsx








var ImageSlider = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8574), __webpack_require__.e(8888)]).then(__webpack_require__.bind(__webpack_require__, 8859));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8859)
            ];
        }
    }
});
var Testimonial = function(param) {
    var heading = param.heading, background = param.background, testimonial_collection = param.testimonial_collection, testimonial_collections = param.testimonial_collections;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            heading && testimonial_collections && /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: classnames_default()((Testimonial_style_module_default()).heading, (Testimonial_style_module_default()).slides_show),
                children: heading
            }),
            testimonial_collections && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider, {
                testimonials: testimonial_collections
            }),
            testimonial_collection && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenContainer/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (style_module_default()).containerMarginS,
                    children: [
                        heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: (Testimonial_style_module_default()).heading,
                            children: heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(item, {
                            background: background,
                            data: testimonial_collection
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 88460:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"childrenContainer":"style_childrenContainer__d3pAq"};

/***/ }),

/***/ 57231:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"markdown":"style_markdown__ACijO"};

/***/ }),

/***/ 91066:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageAndLinkTitle":"style_imageAndLinkTitle____viQ","videoPlayer":"style_videoPlayer__ZQkbF"};

/***/ }),

/***/ 44993:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"style_itemContainer__mbUvI","beforeQuote":"style_beforeQuote__DLmUb","afterQuote":"style_afterQuote__7bHdw","name":"style_name__yjLrT","none":"style_none__CstXI","blueBox":"style_blueBox__Xo3bg","heading":"style_heading__xfegr","slides_show":"style_slides_show__8vVjo","quote":"style_quote__olmtq"};

/***/ }),

/***/ 88415:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"containerMarginL":"style_containerMarginL__Xin_m","containerMarginM":"style_containerMarginM__gcEkK","containerMarginS":"style_containerMarginS__uOEYv","containerPaddingS":"style_containerPaddingS__F37JV","markdownContent":"style_markdownContent__x1pNa"};

/***/ })

}]);